export default {
  VERSION: '2.0',
  // Path is unguessable-by-design; do not add it to robots.txt or link it
  // anywhere outside the AccessControl-gated /guide route.
  GUIDE_PATH: '/guide-25f115e3906bd6a3128bffab246fd7ee/app-guide.html',
};
